function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { window, utils } from 'pro-gallery-lib';
import GalleryDebugMessage from './galleryDebugMessage';
import itemView from '../../item/itemView.js';
import { GalleryComponent } from '../../galleryComponent';

var GalleryView = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(GalleryView, _GalleryComponent);

  function GalleryView(props) {
    var _this;

    _this = _GalleryComponent.call(this, props) || this;
    _this.handleArrowKeys = _this.handleArrowKeys.bind(_assertThisInitialized(_this));
    _this.showMoreItems = _this.showMoreItems.bind(_assertThisInitialized(_this));
    _this.createGalleryConfig = _this.createGalleryConfig.bind(_assertThisInitialized(_this));
    _this.screenLogs = _this.screenLogs.bind(_assertThisInitialized(_this));
    _this.createGallery = _this.createGallery.bind(_assertThisInitialized(_this));
    _this.id = Date.now() + '|' + Math.floor(Math.random() * 10000);
    _this.state = {
      currentIdx: 0
    };
    return _this;
  }

  var _proto = GalleryView.prototype;

  _proto.handleArrowKeys = function handleArrowKeys(e) {
    var activeItemIdx = window.document.activeElement.getAttribute('data-idx');

    if (activeItemIdx) {
      var findNeighborItem = this.props.actions.findNeighborItem || this.props.galleryStructure.findNeighborItem || function () {}; //temp change for tests to pass


      var idx = Number(activeItemIdx);
      var newIdx = -1;

      switch (e.keyCode || e.charCode) {
        case 38:
          //up
          newIdx = findNeighborItem(idx, 'up');
          break;

        case 37:
          //left
          newIdx = findNeighborItem(idx, this.props.styleParams.isRTL ? 'right' : 'left');
          break;

        case 40:
          //down
          newIdx = findNeighborItem(idx, 'down');
          break;

        case 39:
          //right
          newIdx = findNeighborItem(idx, this.props.styleParams.isRTL ? 'left' : 'right');
          break;
      } //if nextIdx is below the lastVisibleItemIdx (higher idx), we will ignore the findNeighborItem answer and stay on the same item


      if (newIdx > this.lastVisibleItemIdx()) {
        newIdx = idx;
      }

      if (newIdx >= 0) {
        e.preventDefault();
        e.stopPropagation();
        utils.setStateAndLog(this, 'Set Gallery Current Item', {
          currentIdx: newIdx
        });
        return false;
      }
    }

    return true;
  };

  _proto.lastVisibleItemIdxInHeight = function lastVisibleItemIdxInHeight(height) {
    for (var i = this.props.galleryStructure.items.length - 1; i >= 0; i--) {
      var item = this.props.galleryStructure.items[i];
      var isVisible = item.offset.top < height;

      if (isVisible) {
        return i;
      }
    }

    return this.items.length - 1;
  };

  _proto.lastVisibleItemIdx = function lastVisibleItemIdx() {
    //the item must be visible and above the show more button
    return this.lastVisibleItemIdxInHeight(this.props.container.galleryHeight - 100);
  };

  _proto.showMoreItems = function showMoreItems() {
    var _this2 = this;

    if (this.props.styleParams.isAccessible) {
      // tal - I left this check since we do not want to focus the last item in non-accessibility mode
      //find the last visible item and focus on it
      try {
        var lastItemIdx = this.lastVisibleItemIdx();
        utils.setStateAndLog(this, 'Focus on Last Gallery Item', {
          currentIdx: lastItemIdx + 1
        }, function () {
          _this2.props.actions.toggleLoadMoreItems();
        });
      } catch (e) {
        console.warn('Cannot find item to focus', e);
      }
    } else {
      this.props.actions.toggleLoadMoreItems();
    }
  };

  _proto.createGallery = function createGallery(showMore) {
    var _this$props = this.props,
        itemsLoveData = _this$props.itemsLoveData,
        styleParams = _this$props.styleParams,
        container = _this$props.container,
        galleryStructure = _this$props.galleryStructure,
        isUnknownWidth = _this$props.isUnknownWidth,
        getVisibleItems = _this$props.getVisibleItems;
    var galleryConfig = this.createGalleryConfig();
    var showMoreContainerHeight = 138; //according to the scss

    var debugMsg = /*#__PURE__*/React.createElement(GalleryDebugMessage, this.props.debug);
    var galleryHeight;

    if (showMore) {
      galleryHeight = container.galleryHeight - showMoreContainerHeight;
    } else {
      galleryHeight = galleryStructure.height + 'px';
    }

    var galleryStructureItems = getVisibleItems(galleryStructure.galleryItems, container);
    var layout = galleryStructureItems.map(function (item, index) {
      return /*#__PURE__*/React.createElement(itemView, item.renderProps(_objectSpread(_objectSpread(_objectSpread({}, galleryConfig), itemsLoveData[item.id]), {}, {
        visible: item.isVisible,
        key: "itemView-" + item.id + "-" + index,
        isUnknownWidth: isUnknownWidth
      })));
    });
    return /*#__PURE__*/React.createElement("div", {
      id: "pro-gallery-container",
      className: 'pro-gallery inline-styles ' + (styleParams.oneRow ? ' one-row slider hide-scrollbars ' : '') + (styleParams.isAccessible ? ' accessible ' : '') + (styleParams.isRTL ? ' rtl ' : ' ltr '),
      style: {
        height: galleryHeight,
        overflowX: 'hidden' //  width: this.props.container.galleryWidth,

      },
      onKeyDown: this.handleArrowKeys
    }, /*#__PURE__*/React.createElement("div", {
      id: "pro-gallery-margin-container",
      style: {
        margin: styleParams.galleryMargin + 'px',
        height: galleryHeight,
        width: this.props.isUnknownWidth ? '100%' : this.props.container.galleryWidth - styleParams.imageMargin * 2,
        overflow: 'visible',
        position: 'relative'
      }
    }, debugMsg, layout));
  };

  _proto.createGalleryConfig = function createGalleryConfig() {
    return {
      scrollingElement: this.props.scrollingElement,
      scroll: this.props.scroll,
      container: this.props.container,
      styleParams: this.props.styleParams,
      watermark: this.props.watermark,
      settings: this.props.settings,
      currentIdx: this.state.currentIdx,
      customHoverRenderer: this.props.customHoverRenderer,
      customInfoRenderer: this.props.customInfoRenderer,
      domId: this.props.domId,
      playingVideoIdx: this.props.playingVideoIdx,
      nextVideoIdx: this.props.nextVideoIdx,
      noFollowForSEO: this.props.noFollowForSEO,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    };
  };

  _proto.screenLogs = function screenLogs() {
    return utils.shouldDebug('screenLogs') ? /*#__PURE__*/React.createElement("div", {
      className: "screen-logs"
    }, "URL width: ", utils.parseGetParam('width'), ", Container:", ' ', JSON.stringify(this.props.container.galleryWidth), ", window.document.body.clientWidth ", document.body.clientWidth, ", window.innerWidth ", window.innerWidth, ", window.screen.width:", ' ', window.screen.width) : '';
  };

  _proto.returnButtonStyle = function returnButtonStyle(styleParams) {
    var btnStyle = {};

    if (utils.isMobile()) {
      if (typeof styleParams.loadMoreButtonFont !== 'undefined') {
        btnStyle.font = styleParams.loadMoreButtonFont.value;
        btnStyle.textDecoration = styleParams.textDecorationLoadMore;
      }

      if (typeof styleParams.loadMoreButtonFontColor !== 'undefined') {
        btnStyle.color = styleParams.loadMoreButtonFontColor.value;
        btnStyle.textDecorationColor = styleParams.loadMoreButtonFontColor.value;
      }

      if (typeof styleParams.loadMoreButtonColor !== 'undefined') {
        btnStyle.background = styleParams.loadMoreButtonColor.value;
      }

      if (typeof styleParams.loadMoreButtonBorderColor !== 'undefined') {
        btnStyle.borderColor = styleParams.loadMoreButtonBorderColor.value;
      }

      if (typeof styleParams.loadMoreButtonBorderRadius !== 'undefined') {
        btnStyle.borderRadius = styleParams.loadMoreButtonBorderRadius;
      }

      if (typeof styleParams.loadMoreButtonBorderWidth !== 'undefined') {
        btnStyle.borderWidth = styleParams.loadMoreButtonBorderWidth;
      }
    }

    return btnStyle;
  };

  _proto.createShowMoreButton = function createShowMoreButton() {
    if (typeof this.props.customLoadMoreRenderer === 'function') {
      return /*#__PURE__*/React.createElement("div", {
        onClick: this.showMoreItems
      }, this.props.customLoadMoreRenderer(this.props));
    }

    var styleParams = this.props.styleParams;
    var showMoreButton = false;
    var buttonState = this.props.displayShowMore;
    var shouldShowButton = buttonState && this.props.galleryStructure.height > this.props.container.height;
    var btnStyle = this.returnButtonStyle(styleParams);

    if (shouldShowButton) {
      var buttonText = styleParams.loadMoreButtonText || 'Load More';
      showMoreButton = /*#__PURE__*/React.createElement("div", {
        className: 'show-more-container' + (utils.isMobile() ? ' pro-gallery-mobile-indicator' : '')
      }, /*#__PURE__*/React.createElement("button", {
        tabIndex: utils.getTabIndex('loadMoreButton'),
        id: 'show-more-' + this.props.domId,
        className: "show-more",
        onClick: this.showMoreItems,
        "data-hook": "show-more",
        "aria-label": buttonText,
        style: btnStyle
      }, buttonText));
    }

    return showMoreButton;
  } //-----------------------------------------| RENDER |--------------------------------------------//
  ;

  _proto.render = function render() {
    if (utils.isVerbose()) {
      console.count('galleryView render');
      console.time('Rendering Gallery took ');
      console.log('[DEBUG_RENDER] GalleryView styleParams', this.props.styleParams);
      console.log('[DEBUG_RENDER] GalleryView props changed', utils.printableObjectsDiff(this.lastProps || {}, this.props));
      this.lastProps = _objectSpread({}, this.props);
      console.log('[DEBUG_RENDER] GalleryView state changed', utils.printableObjectsDiff(this.lastState || {}, this.state));
      this.lastState = _objectSpread({}, this.state);
      this.renderCount = (this.renderCount || 0) + 1;
    }

    var showMore = this.createShowMoreButton();
    var gallery = this.createGallery(showMore);

    if (utils.isVerbose()) {
      console.timeEnd('Rendering Gallery took ');
    }

    var screenLogs = this.screenLogs();
    return /*#__PURE__*/React.createElement("div", {
      className: 'pro-gallery-parent-container',
      key: "pro-gallery-" + this.id,
      role: "region",
      "aria-label": this.props.proGalleryRegionLabel
    }, screenLogs, gallery, showMore);
  };

  return GalleryView;
}(GalleryComponent);

export default GalleryView;